import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Slider from "react-slick/lib";
import ReactHtmlParser from "react-html-parser";
import styles from "./styles";
import Link from "../../Link";

const useStyles = makeStyles((theme) => styles(theme));

const settings = {
  dots: true,
  arrows: true,
  infinite: true,
};

export const CgbVacancySliderBlock = (props) => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query LatestVacancy {
      allWpPub(filter: { PubData: { availableForTenancy: { eq: true } } }) {
        nodes {
          PubData {
            name
            pubOoh
            displayLocation
            availableForTenancy
            featuredImage
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { fit: COVER, cropFocus: CENTER }
                )
              }
            }
            featured
            tenancyStatus
            area
          }
          id
          slug
        }
      }
    }
  `);

  let vacancies = [];

  let count = 0;

  data.allWpPub.nodes.forEach((item) => {
    // console.log(item);
    if (item.PubData.featured === true) {
      count++;
      item.PubData.id = item.id;
      item.PubData.slug = item.slug;
      if (item.PubData.pubOoh) {
        item.PubData.pubOoh = item.PubData.pubOoh.replace(
          "[displayLocation]",
          item.PubData.displayLocation
        );
        item.PubData.pubOoh = item.PubData.pubOoh.replace(
          "[area]",
          item.PubData.area
        );
      }
      if (item.PubData.availableForTenancy === true) {
        vacancies.push(item.PubData);
      }
    }
  });

  data.allWpPub.nodes.forEach((item) => {
    if (item.PubData.featured !== true && count < 5) {
      count++;
      item.PubData.id = item.id;
      item.PubData.slug = item.slug;
      if (item.PubData.pubOoh !== null) {
        item.PubData.pubOoh = item.PubData.pubOoh.replace(
          "[displayLocation]",
          item.PubData.displayLocation
        );
        item.PubData.pubOoh = item.PubData.pubOoh.replace(
          "[area]",
          item.PubData.area
        );
      }
      if (item.PubData.availableForTenancy === true) {
        vacancies.push(item.PubData);
      }
    }
  });

  return (
    <div
      className={`vacancy-slider ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.vacancySlider} ${classes.vacancySliderTheme}`}
    >
      <h2>Latest Vacancy</h2>
      <Slider {...settings}>
        {vacancies.map((vacancy) => {
          let tenancyTagClass = "";

          if (
            vacancy &&
            vacancy.tenancyStatus &&
            typeof vacancy.tenancyStatus === "string"
          ) {
            tenancyTagClass = vacancy.tenancyStatus.toLowerCase();
            tenancyTagClass = tenancyTagClass.replace(" ", "-");
          }

          return (
            <div className="slide" key={vacancy.id}>
              <div class="tags">
                {vacancy.tenancyStatus && (
                  <div className={tenancyTagClass}>{vacancy.tenancyStatus}</div>
                )}
                {vacancy.featured === true && (
                  <div className="featured">Featured</div>
                )}
              </div>
              <div className="mobile ooh">{vacancy.pubOoh}</div>
              <div className="gatsby-image-wrapper vacancy-image">
                <div style={{ paddingBottom: "68%" }} />
                <img
                  src={vacancy.featuredImage}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center center",
                  }}
                  alt=""
                />
              </div>
              <div className="vacancy-info">
                <div className="desktop ooh">{vacancy.pubOoh}</div>
                <div className="vacancy-name">
                  <h3>{ReactHtmlParser(vacancy.name)}</h3>
                  <p>{vacancy.displayLocation}</p>
                </div>
                <Link to={"/tenancy/" + vacancy.slug}>View Opportunity</Link>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CgbVacancySliderBlockFragment = graphql`
  fragment CgbVacancySliderBlock on WpBlock {
    ... on WpCgbVacancySliderBlock {
      name
      attributes {
        className
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbVacancySliderBlockPreview = `
    ... on CgbVacancySliderBlock {
        name
        attributes {
            className
        }
    }
`;
